import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"

export const sendOtp = data => post(url.OTP_SEND, data);
export const verifyOtp = data => post(url.OTP_VERIFY, data);
